var file_upload_viewer_default = {
  "fontElementMap": "nd-0A",
  "file_upload_container": "iGCCb",
  "file_upload_link": "Z1AuN",
  "file_upload_error_container": "vkcD9",
  "file_upload_file_info": "LDFgZ",
  "file_upload_type_icon": "qEw5V",
  "file_upload_status_icon_container": "imeCq",
  "file_upload_status_icon": "A4-V7",
  "file_upload_description": "b0oPt",
  "file_upload_name_container": "_9bIBl",
  "file_upload_name": "s4jXB",
  "file_upload_extension": "_90s8Y",
  "file_loader_icon": "mqJmM",
  "file_upload_icon_frame": "XcRAt",
  "file_upload_icon_background": "YP-gR"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
